module.exports = require('./helpers/bundle-url').getBundleURL('iQ9Fn') + "logo-dark.eefe0b7f.svg";